import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccommodationTypeViewModel from '../ViewModels/AccommodationTypeViewModel';
import { SelectValidator } from 'react-material-ui-form-validator';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IAccommodationTypeDropDownProps {
    setAccomodationType?: (event) => void;
    accommodationType: number | undefined;
    disabled: boolean;
}

interface IAccommodationTypeDropDownState {
    model: AccommodationTypeViewModel[];
    loaded: boolean;
}

class AccommodationTypeDropDown extends Component<IAccommodationTypeDropDownProps & WithStyles<typeof styles>, IAccommodationTypeDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetAccommodationTypes').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultAccommodationTypeVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="What type of accommodation is your term time address?"
                name="accommodationType"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.accommodationType}
                onChange={this.props.disabled ? undefined : this.props.setAccomodationType}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(AccommodationTypeDropDown);